export default {
  searchResults: [],
  providers: [],
  provider: null,
  partner: null,
  partners: [],
  providerAuthInfo: null,
  providerFeedback: null,
  start: null,
  end: null,
  sharingLink: null,
  localProviderList: []
}



// WEBPACK FOOTER //
// ./src/store/modules/provider/state.js